import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ProjectSelector } from '../project-list/data-access/+state/project-list.selectors';
import useFetchActiveProject from '../../../hooks/useFetchActiveProject';
import ProjectOverviewDashboard from './ProjectOverview/ProjectOverviewDashboard';

const Dashboard = () => {
  const activeProject = useSelector(ProjectSelector.activeProject);
  useFetchActiveProject();
  return (
    <>
      <div className="pb-5">
        <Row className="g-4">
          <Col xs={12} xxl={12}>
            <div className="mb-4">
              <h4 className="mb-2">Dashboard for {activeProject?.title}</h4>
              <h5 className="text-body-tertiary fw-semibold">
                Governance snapshot with charts and expandable detail for each domain.
              </h5>
            </div>
            <ProjectOverviewDashboard />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Dashboard;
